import { createAction } from '@reduxjs/toolkit';
import type { MapSettingsToolsStateActiveTool } from './mapSettingsToolsStateActiveTool.state';

// Dispatched when the (explicit or inferred) active tool differs from the one the map was showing before
export const activeToolChanged = createAction(
  'MAP_SETTINGS-TOOLS_STATE-ACTIVE_TOOL-CHANGED',
  (newTool: MapSettingsToolsStateActiveTool, previousTool: MapSettingsToolsStateActiveTool | null) => ({
    payload: { newTool, previousTool },
  })
);
